import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import CategoryDropdown from './CategoryDropdown';
import FactoryDropdown from './FactoryDropdown';

const ReassignModal = ({ 
    handleClose, show, onAdd, formid, factory, categoryID, 
    category, subcategoryID, subcategory, issueID, issue }) => {
    const [selectfactory, setSelectFactory] = useState([]);
    const [selectCategory, setSelectCategory] = useState([]);
    const [selectSubCategory, setSelectSubCategory] = useState([]);
    const [selectIssueCategory, setSelectIssueCategory] = useState([]);

    useEffect(() => {
        setSelectFactory(factory);
        setSelectCategory(categoryID);
        setSelectSubCategory(subcategoryID);
        setSelectIssueCategory(issueID);
    }, [factory, categoryID, subcategoryID, issueID]);

    const getFactory = (factoryProp) => {
        setSelectFactory(factoryProp);
    };

    const getCategory = (CategoryProp) => {
        setSelectCategory(CategoryProp);
    };

    const getSubCategory = (SubCategoryProp) => {
        setSelectSubCategory(SubCategoryProp);
    };

    const getIssueCategory = (IssueCategoryProp) => {
        setSelectIssueCategory(IssueCategoryProp);
    };

    const onSubmit = (e) => {
        e.preventDefault();

        if (selectfactory == "") {
            alert('Please select a factory');
        } else if (selectCategory == "") {
            alert('Please select a category');
        } else if (selectSubCategory == "") {
            alert('Please select a sub category');
        } else if (selectIssueCategory == "") {
            alert('Please select a issue');
        } else {
            if(!window.confirm('Do you want to submit this?')) {
                return false;
            }

            onAdd({
                formid,
                selectfactory,
                selectCategory,
                selectSubCategory,
                selectIssueCategory,
            });
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    Reassign Grievance Form
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form 
                onSubmit={onSubmit}
                >
                    <Form.Group className='mb-3'>
                        <Form.Label>Factory</Form.Label>
                        <FactoryDropdown
                        getFactory={getFactory} factory={factory}
                        />
                    </Form.Group>
                    <CategoryDropdown
                    getCategory={getCategory} categoryID={categoryID} category={category}
                    getSubCategory={getSubCategory} subcategoryID={subcategoryID} subcategory={subcategory}
                    getIssueCategory={getIssueCategory} issueID={issueID} issue={issue}
                    />
                    <Button as='input' type='submit' value='Reassign' />
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ReassignModal;
